export const COLORS = {
  // Core brand
  PRIMARY_WHITE: "#ffffff",
  PRIMARY_BLACK: "#000000",
  COLOR_DARK: "#293461",
  BTN_GREEN: "#00838c",
  BTN_GREEN_DARK: "#066B73",

  // Surfaces & borders
  HEADER_BORDER: "#e1e3ee",
  BORDER_GREY: "#e1e3ee",
  TABLE_GREY_CELL: "#f4f6ff",
  INPUT_BACKGROUND: "#f9f9f9",
  INPUT_BORDER: "#e1e3ee",
  LIGHT_BLUE: "#f8faff",

  // Text
  INPUT_LABEL: "#949ab0",
  INPUT_GRAY: "#aaaaaa",
  TRANSCRIPT_GRAY: "#8294a5",

  // Actions
  HYPERLINK: "#007aff",
  LOGOUT_RED: "#d91b1b",
  REMOVE_RED: "#ff3c3c",
  WARNING: "#d97706",

  // Notifications
  NOTIFICATION_GREEN: "rgba(89, 179, 48, 0.1)",
  NOTIFICATION_ORANGE: "rgba(246,180,54, 0.1)",
  NOTIFICATION_BLUE: "rgba(41,52,97, 0.1)",
  NOTIFICATION_RED: "rgba(225,0,0, 0.1)",

  // Box / badge accents
  BOX_BLUE: "#0000FF",
  BOX_DARKGREEN: "#006400",
  BOX_DEEPPINK: "#FF1493",
  BOX_DARKMAGENTA: "#8B008B",
  BOX_INDIGO: "#4B0082",
  BOX_OLIVE: "#808000",

  HIGHLIGHT_COLOR: "#69e3c2",
};

export const T = {
  // Primary palette
  teal: COLORS.BTN_GREEN,
  tealDark: COLORS.BTN_GREEN_DARK,
  tealTint: "#e6f4f5",
  tealLight: "#b2dde1",
  navy: COLORS.COLOR_DARK,
  navyTint: "#eceef6",

  // Text
  ink: COLORS.COLOR_DARK,
  mute: COLORS.INPUT_LABEL,
  subtle: COLORS.INPUT_GRAY,

  // Surfaces
  white: COLORS.PRIMARY_WHITE,
  soft: COLORS.LIGHT_BLUE,
  line: COLORS.BORDER_GREY,

  // Status
  success: "#15803D",
  successTint: "#F0FDF4",
  warn: "#854D0E",
  warnTint: "#FFFBEB",
  warnBorder: "#F6B436",
  red: COLORS.REMOVE_RED,
  highlight: COLORS.HIGHLIGHT_COLOR,
};

export const FONTS = {
  primaryFontBold: "openSans-bold, sans-serif",
  primaryFontBoldItalic: "openSans-BoldItalic, sans-serif",
  primaryFontCondLight: "openSans-CondLight, sans-serif",
  primaryFontCondLightItalic: "openSans-CondLightItalic, sans-serif",
  primaryFontExtraBold: "openSans-ExtraBold, sans-serif",
  primaryFontExtraBoldItalic: "openSans-ExtraBoldItalic, sans-serif",
  primaryFontItalic: "openSans-Italic, sans-serif",
  primaryFontLight: "openSans-Light, sans-serif",
  primaryFontLightItalic: "openSans-LightItalic, sans-serif",
  primaryFontRegular: "openSans-Regular, sans-serif",
  primaryFontSemiBold: "openSans-SemiBold, sans-serif",
  // Fallback mono
  mono: "ui-monospace, SFMono-Regular, Menlo, monospace",
};

export const FS = {
  xs: "clamp(9px,  0.75vw, 10px)",
  sm: "clamp(10px, 0.85vw, 11px)",
  base: "clamp(11px, 0.9vw,  12.5px)",
  md: "clamp(12px, 0.95vw, 13.5px)",
  lg: "clamp(13px, 1vw,    15px)",
  xl: "clamp(14px, 1.1vw,  17px)",
  h3: "clamp(15px, 1.2vw,  18px)",
  h2: "clamp(17px, 1.4vw,  22px)",
};

export const BP = {
  mobile: "480px",
  tablet: "600px",
  desk: "900px",
};
